module.exports = __webpack_public_path__ + "static/media/new-york-city.0989827f.json";


//////////////////
// WEBPACK FOOTER
// ./src/assets/geojson/new-york-city.json
// module id = 294
// module chunks = 27